export default __webpack_public_path__ + "static/media/icon_pst_Python.7ee438a9.svg";